export default "__VITE_ASSET__DaKf2B____"